"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _TableCellStyles = require("./TableCell.styles.js");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// External
// Resources
var TableCell = function TableCell(_ref) {
  var basis = _ref.basis,
      className = _ref.className,
      cellContent = _ref.cellContent,
      hasErrors = _ref.hasErrors,
      isBold = _ref.isBold,
      titleBar = _ref.titleBar;
  var content = cellContent.content,
      label = cellContent.label,
      align = cellContent.align;
  return /*#__PURE__*/_react.default.createElement(_TableCellStyles.TableCellContainer, {
    className: className,
    "data-test-id": "table-cell",
    hasErrors: hasErrors,
    basis: basis,
    align: align || 'center',
    titleBar: titleBar
  }, !label ? /*#__PURE__*/_react.default.createElement(_TableCellStyles.TableCellContentContainer, {
    className: "c-table-cell-content-container"
  }, /*#__PURE__*/_react.default.createElement(_TableCellStyles.TableCellContent, {
    className: "c-table-cell-content",
    isBold: isBold
  }, content || cellContent || '')) : /*#__PURE__*/_react.default.createElement(_TableCellStyles.TitleBarContentContainer, {
    className: "c-table-cell-content-container"
  }, /*#__PURE__*/_react.default.createElement(_TableCellStyles.TableCellContent, {
    className: "c-table-cell-content",
    isBold: isBold
  }, content || ''), /*#__PURE__*/_react.default.createElement(_TableCellStyles.TableCellLabel, {
    className: "c-table-cell-label"
  }, label.toUpperCase())));
};

TableCell.propTypes = {
  /** Class Overrides */
  className: _propTypes.default.string,

  /** Content to be displayed in the cell */
  cellContent: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.object]).isRequired,

  /** Flag to turn rootBorders to error state */
  hasErrors: _propTypes.default.bool.isRequired,

  /** (optional) Bolds text */
  isBold: _propTypes.default.bool,

  /** (optional) Flag to add titlebar styling */
  titleBar: _propTypes.default.bool,

  /** The basis to apply to the cell for width */
  basis: _propTypes.default.number.isRequired
};
TableCell.defaultProps = {
  className: '',
  isBold: false,
  titleBar: false
};
var _default = TableCell;
exports.default = _default;